import typeCheck from 'common/util/typeCheck';

export default async function setPhotoResolution({ state }, { resolution }) {
  typeCheck('resolution::PositiveNumber', resolution);
  state.set(['listingPhotoResolution'], resolution);
  state.commit();
}
